// Constants.tsx

import LandContractType from 'src/models/LandContractType';
import { ODataOrderByDirection } from 'src/util/ODataBuilder';

export const landTractTypes = Object.freeze({
    SURFACE : 'Surface',
    MINERAL : 'Mineral'
});

export const contractStatus = Object.freeze({
    OPEN : 'Open',
    LEASED : 'Leased'
});

export const contractTypeRef = Object.freeze({
    OIL_AND_GAS : {value: LandContractType.OilAndGas, label: 'Oil and Gas Lease'},
    SURFACE_WAIVER : {value: LandContractType.SurfaceWaiver, label: 'Surface Waiver'},
    SOLAR : {value: LandContractType.SolarLease, label: 'Solar Lease'},
    BATTERY_STORAGE : {value: LandContractType.BatteryStorage, label: 'BESS Lease'},
    BRINE_LEASE : {value: LandContractType.BrineLease, label: 'Brine Lease'},
    RIGHT_OF_WAY : {value: LandContractType.RightOfWay, label: 'Right Of Way'},
    CARBON_CAPTURE : {value: LandContractType.CarbonCapture, label: 'Carbon Capture System'}
});

export const documentTemplateTypes = Object.freeze({
    LEASE_TEMPLATE : 'Lease Template',
    ORDER_OF_PAYMENT : 'Order of Payment',
    MEMO: 'Memo',
    ASSIGNMENT: 'Assignment'
});

export const LeaseStatus = Object.freeze({
    ROUGH_DRAFT : 1,
    IN_HAND : 2,
    INVOICED : 3,
    RECORDED : 4,
    TRANSMITTED : 5,
    VOID : 6
});

export const rightOfWayLeaseType = Object.freeze({
    ROW : 'ROW Agreement',
    AGE : 'Above Ground Easement',
    AM : 'Amendment',
    DOH : 'DOH Driveway',
    IL : 'Intake Lease',
    LAG : 'License Agreement',
    PAR : 'Permanent Access Road',
    SLA : 'Surface Lease Agreement',
    SP : 'Survey Permission',
    TAR : 'Temporary Access Road',
    TWS : 'Temporary Work Space',
    VAL : 'Valve Set',
    WAV : 'Waiver',
    XNG : 'Crossing',
    YRD : 'Yard Lease'
});

// Constant representing the ratio of rods to feet.
export const rodToFeetConversion = 16.5;

// The delay (in ms) for query execution while typing in a search query on the GIS Data Access Page
export const gisDataAccessSearchDebounceDelay = 800;

// The number of rows to return for each paginated request for GIS Horizons in a search query on the GIS Data Access Page.
export const gisDataAccessSearchRowCount = 15;

// The number of rows to return for each paginated requrest for projects on the Clients Page.
export const clientPageProjectListDefaultRowCount = 15;
export const clientPageProjectQueryOrderByIdColumn = 'Id';
export const clientPageProjectQueryOrderByNameColumn = 'Name';
export const clientPageProjectQueryOrderByProjectNumberColumn = 'ProjectNumber';
export const clientPageProjectQueryStartingPage = 1;

// Constants for Pagination in the SearchPanel Component.
export const SearchPanelQueryNoOpResult = 'SearchPanelQueryNoOpResult';
export const SearchPanelTagListDefaultRowCount = 15;
export const SearchPanelQueryOrderByNameColumn = 'Name';
export const SearchPanelQueryStartingPage = 1;
export const SearchPanelTagListQueryOrderByDirection = ODataOrderByDirection.Descending;

// The number of bytes that a file can be in order to be contained in a FormData File blob
export const MaxUploadFileSizeBytes: number = 29360128;

// Default Lessee
export const DefaultLesseePageFormSubmitText = 'Submit';
export const ProvisionalOwnerName = 'provisional';

// Get index 0 because on the leaseinfo.redesign.tsx page, only one leasehold at a time is fetched
export const leaseInfoPagedefaultLeaseholdIndex = 0;
export const refreshMORReportFileType = 2;

export const accountsPayableVoucherAccountsBlankAccountsBase = 999000;
export const accountsPayableVoucherAccountsUnsavedAccountsBase = 1000000;



// WEBPACK FOOTER //
// ./src/components/common/Constants.tsx